<template lang="pug">
extends order-layout-add-cell-base.pug
block content
    .list.inset
        .list-item.pointer(v-for="group in groupOptions", :key="group.id", @click="toggleItem(group)")
            .list-body
                p.pull-right
                    i.material-icons.md-24(:class="{ 'item-checked': itemAdded(group), 'text-muted': !itemAdded(group) }") {{ itemAdded(group) ? 'check_box' : 'check_box_outline_blank' }}
                span._400.block {{ group.name }}
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import addCellMixin from './mixins/order-layout-add-cell';

export default {
    mixins: [addCellMixin],

    computed: {
        ...mapGetters('orderLayout', [
            'hasActiveGroup',
            'groupDisplay',
            'activeGroup',
        ]),

        ...mapGetters('orderLayout', {
            totalRecords: 'totalRecords',
        }),

        // group listed must not in current active groups and parents
        groupOptions() {
            if (this.hasActiveGroup) {
                // exclude current self group
                return this.groupDisplay.filter(
                    g => g.id != this.activeGroup.id,
                );
            }

            return this.groupDisplay;
        },

        options() {
            return this.groupOptions;
        },
    },

    created() {
        this.useFilter = true;
        this.usePagination = true;
        this.setItemType('group');
    },

    mounted() {
        this.$on('cell-added', cell => {
            const group_id = cell.action.id;
            if (!this.getGroupPages(group_id).length)
                this.addPage({ group_id });
        });
    },

    methods: {
        ...mapActions('orderLayout', [
            'setOrCreatePageCell',
            'addPage',
            'getDisplayGroupList',
            'createGroup',
        ]),

        getGroup() {
            let options = {
                query: this.query,
                limit: this.pagination.perPage,
                page: this.pagination.page,
            };

            this.getDisplayGroupList(options);
        },

        fetchByQuery: _.debounce(function() {
            this.setPage(1);
            this.$refs.pagination.setPage(1);
            this.getGroup();
        }, 500),

        onPaginate(page) {
            this.setPage(page);
            this.getGroup();
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/order-layout/order-layout-add-group.vue